var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectorKadap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(-255 -147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M13.963,35.778a11.825,11.825,0,0,0,11.371-8.592H20.407a8.6,8.6,0,0,1-8.593-8.593V12.342a11.817,11.817,0,0,0,2.148,23.436m0,2.148a13.963,13.963,0,0,1,0-27.926v8.593a6.452,6.452,0,0,0,6.445,6.445h7.478A13.964,13.964,0,0,1,13.963,37.926Z",
    transform: "translate(255 138.074)",
    fill: "#1a286d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    d: "M2.438,0h0A10.563,10.563,0,0,1,13,10.563v0A2.438,2.438,0,0,1,10.563,13H2.438A2.438,2.438,0,0,1,0,10.563V2.438A2.438,2.438,0,0,1,2.438,0Z",
    transform: "translate(272 147)",
    fill: "#ff6c00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectorKadap);
export default __webpack_public_path__ + "static/media/sector-kadap.fc2b75b5.svg";
export { ForwardRef as ReactComponent };